<template>
<div class="home">   
  <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" @select="handleSelect" router active-text-color="#409eff">
  <div class="nav_box">
 
  <div class="txt_box row">
     <el-menu-item index="/homepage"><img src="../assets/home/ROCMOSLOGO.png" alt=""></el-menu-item>
      <el-menu-item index="/homepage">首页</el-menu-item>
  <el-submenu index="2">
    <template slot="title">产品</template>
    <el-menu-item index="/rocbox">ROCBOX</el-menu-item>
    <el-menu-item index="2-2">选项2</el-menu-item>
    <el-menu-item index="2-3">选项3</el-menu-item>
  </el-submenu>
  <el-menu-item index="/solution">解决方案</el-menu-item>
   <el-menu-item index="/cases">案例</el-menu-item>
    <el-submenu index="5">
    <template slot="title">支持与服务</template>
    <el-menu-item index="/download">RocMoS软件下载</el-menu-item>
    <el-menu-item index="/aboutus">关于我们</el-menu-item>
  </el-submenu>
  </div>
  <div class="btn_box row">
  <el-menu-item index="/register"><el-button type="primary" round>免费注册</el-button></el-menu-item>
  <el-menu-item index="/login"> <el-button round>登录</el-button></el-menu-item>
    </div>
 
    </div>
</el-menu>
  <!-- 公共的部分 -->

      <router-view></router-view>


      


    </div>
</template>
<style>
.el-menu.el-menu--horizontal {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #409eff !important;
}
.nav_box {
  width: 12rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  outline: none;
}
.el-submenu__icon-arrow {
  position: absolute;
  top: 50%;
  right: 0 !important;
  margin-top: -7px;
}
.el-submenu__title,
.el-menu-item {
  font-size: 0.16rem !important;
  font-weight: 400;
}
.el-menu-item:focus,
.el-menu-item:hover,
.el-submenu__title:focus,
.el-submenu__title:hover {
  color: #409eff;
  background-color: #fff;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #409eff;
}
.txt_box,
.btn_box{
  justify-content: flex-start;
}
</style>
<script>
export default {
  data() {
    return {
      activeIndex: "/homepage"
    };
  },
  watch:{
    $route(){
      this.handleSelect(this.activeIndex)
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex=key
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/homemain.vue